import React, { useState, useEffect } from 'react';
import '../../../../../Stylesheets/Profile/SettingsTab.css';
import { FaChevronRight } from 'react-icons/fa';

import { useDispatch, useSelector } from 'react-redux';
import { updateUserSettings } from '../../../../../Redux/Auth/authSlice';
import { showFeedback } from '../../../../../Redux/UI/uiFeedbackSlice';

import ChangePasswordModal from '../Modal/ChangePasswordModal';
import { getAuth } from 'firebase/auth';

const SettingsTab = () => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);

  const [notifications, setNotifications] = useState(false);
  const [language, setLanguage] = useState('English');
  const [timezone, setTimezone] = useState('Auto (UTC +05.30)');
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    if (user?.settings) {
      setNotifications(user.settings.notifications ?? false);
      setLanguage(user.settings.language || 'English');
      setTimezone(user.settings.timezone || 'Auto (UTC +05.30)');
    }
  }, [user]);

  // ✅ compute directly (no stale memo nonsense)
  const fbUser = getAuth().currentUser;
  const canChangePassword = (fbUser?.providerData || []).some(
    (p) => p?.providerId === 'password'
  );

  const handleOpenChangePassword = () => {
    // extra safety
    if (!fbUser) {
      dispatch(
        showFeedback({
          type: 'error',
          title: 'Not signed in',
          message: 'Please sign in again to change your password.',
        })
      );
      return;
    }

    if (!canChangePassword) {
      dispatch(
        showFeedback({
          type: 'info',
          title: 'Password not available',
          message:
            'You signed in with Google. Change Password works only for email/password accounts.',
        })
      );
      return;
    }

    setShowChangePassword(true);
  };

  const handleSaveSettings = async () => {
    try {
      const action = await dispatch(
        updateUserSettings({
          token,
          settings: { notifications, language, timezone },
        })
      );

      if (updateUserSettings.rejected.match(action)) {
        const msg =
          action.payload?.message ||
          action.error?.message ||
          'Failed to save settings.';

        dispatch(
          showFeedback({
            type: 'error',
            title: 'Save failed',
            message: msg,
          })
        );
        return;
      }

      dispatch(
        showFeedback({
          type: 'success',
          title: 'Saved',
          message: 'Settings saved successfully.',
        })
      );
    } catch (err) {
      console.error(err);
      dispatch(
        showFeedback({
          type: 'error',
          title: 'Save failed',
          message: 'Failed to save settings.',
        })
      );
    }
  };

  return (
    <>
      <div className="profile-page-settings-tab">
        <div
          className="profile-page-setting-row clickable"
          onClick={handleOpenChangePassword}
          style={!canChangePassword ? { opacity: 0.65 } : undefined}
          title={!canChangePassword ? 'Google account: password change not available' : ''}
        >
          <span className="profile-page-label">Change Password</span>
          <span className="profile-page-value masked">
            ********** <FaChevronRight />
          </span>
        </div>

        {/* <div className="profile-page-setting-row">
          <span className="profile-page-label">Notification</span>
          <label className="profile-page-switch">
            <input
              type="checkbox"
              checked={notifications}
              onChange={() => setNotifications(!notifications)}
            />
            <span className="profile-page-slider round"></span>
          </label>
        </div> */}

        {/* <div className="profile-page-setting-row">
          <span className="profile-page-label">
            Dark Mode <span className="profile-page-soon">(Coming Soon)</span>
          </span>
          <label className="profile-page-switch">
            <input type="checkbox" disabled />
            <span className="profile-page-slider round"></span>
          </label>
        </div> */}

        {/* <div className="profile-page-setting-row">
          <span className="profile-page-label">Language</span>
          <select value={language} onChange={(e) => setLanguage(e.target.value)}>
            <option>English</option>
            <option>Hindi</option>
            <option>Marathi</option>
          </select>
        </div> */}

        {/* <div className="profile-page-setting-row">
          <span className="profile-page-label">Timezone</span>
          <select value={timezone} onChange={(e) => setTimezone(e.target.value)}>
            <option>Auto (UTC +05.30)</option>
            <option>UTC +00.00</option>
            <option>UTC +01.00</option>
            <option>UTC +09.30</option>
          </select>
        </div> */}

        <button className="profile-page-edit-settings-btn" onClick={handleSaveSettings}>
          Save Settings
        </button>
      </div>

      {showChangePassword && (
        <ChangePasswordModal onClose={() => setShowChangePassword(false)} />
      )}
    </>
  );
};

export default SettingsTab;
